<script setup lang="ts">
import { computed } from 'vue';
import { RouterLink } from 'vue-router';
import catLogo from '@app/assets/images/icons/profile_cat_icon.png';

const props = withDefaults(defineProps<{
  size?: 'sm' | 'md';
  showText?: boolean;
  link?: boolean;
  /** Where the linked variant navigates. Defaults to the marketing home '/'. */
  to?: string;
}>(), {
  size: 'md',
  showText: true,
  link: true,
  to: '/',
});

const iconSize = computed(() => (props.size === 'sm' ? 'h-5 w-5' : 'h-6 w-6'));
// The cream paper disc the cat sits on (icon + ~4px stock margin).
const discSize = computed(() => (props.size === 'sm' ? 'h-7 w-7' : 'h-8 w-8'));
const textSize = computed(() => (props.size === 'sm' ? 'text-lg' : 'text-xl'));
</script>

<template>
  <!-- Linked variant (nav/footer/header): the brand mark navigates home. -->
  <RouterLink
    v-if="link"
    :to="to"
    class="flex items-center gap-2.5 font-serif tracking-[0.02em] transition-opacity hover:opacity-80"
  >
    <span :class="[discSize, 'brand-disc paper-tag grid shrink-0 place-items-center']">
      <img :src="catLogo" alt="" :class="[iconSize, 'object-contain brightness-0 opacity-80']" />
    </span>
    <span v-if="showText" :class="[textSize, 'text-foreground']">Таро Мяу</span>
  </RouterLink>

  <!-- Static variant (desktop phone-frame top bar): plain, non-clickable. -->
  <div
    v-else
    class="flex items-center gap-2.5 font-serif tracking-[0.02em] text-foreground"
  >
    <span :class="[discSize, 'brand-disc paper-tag grid shrink-0 place-items-center']">
      <img :src="catLogo" alt="" :class="[iconSize, 'object-contain brightness-0 opacity-80']" />
    </span>
    <span v-if="showText" :class="[textSize, 'text-foreground']">Таро Мяу</span>
  </div>
</template>

<style scoped>
/* Her white chalk cat, inked dark on a tiny cream paper disc: a hand-cut,
   slightly uneven circle with a 1px lip and a short soft cast (box-shadow —
   the disc is not clipped). Static. */
.brand-disc {
  border-radius: 52% 48% 50% 46% / 48% 52% 46% 50%;
  box-shadow: 0 1px 0 rgb(4 3 18 / 0.5), 0 3px 6px -3px var(--paper-shade);
}
</style>
